module.exports = __webpack_public_path__ + "img/menu-on_04.9fed7b48.png";